import { createSelector } from 'reselect';

import { EMPTY_OBJECT } from 'utils/object';

import { ReduxStore } from '../types';

export const getEpgState = (state: ReduxStore) => state.epg;

export const selectEpgRequestStatus = createSelector(
    getEpgState,
    (epgState) => epgState.epg.status,
);

export const selectEpgParams = createSelector(
    getEpgState,
    ({ epg: { start, end, requestedBy } }) => ({
        start,
        end,
        requestedBy,
    }),
);

export function selectEpgPlayerFullscreen(store: ReduxStore) {
    return store.epg.fullscreen;
}

export const selectEpgProgramsByChannelsIds = createSelector(
    getEpgState,
    ({ epg: { data, start, end } }) => {
        const dateKey = `${start}-${end}`;

        return data[dateKey] || EMPTY_OBJECT;
    },
);

export function selectPreviouslyWatchedChannel(store: ReduxStore) {
    return store.epg.previouslyWatchedChannelByProfile;
}

export function getSubtitlesDialogVisible(store: ReduxStore) {
    return store.epg.subtitlesDialogVisible;
}

export function getFocusToNow(store: ReduxStore) {
    return store.epg.focusToNow;
}

export function getEpgLastUpdated(store: ReduxStore) {
    return store.epg.epgLastUpdated;
}

export function getNewDayIsLoading(store: ReduxStore) {
    return store.epg.epg.newDayIsLoading;
}

export function getEpgSelectedLayout(store: ReduxStore) {
    return store.epg.epgSelectedLayout;
}
